import React, { useState } from 'react';
import { Box, IconButton, Stack, Typography } from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { EditNotesDialog } from './EditNotesDialog';
import { editButtonOffsetSx } from '../../App';

interface MemberNotesProps {
  notes?: string | null;
  editMode: boolean;
  onSaveNotes: (notes: string) => void;
}

export const MemberNotes: React.FC<MemberNotesProps> = ({ notes, editMode, onSaveNotes }) => {
  const [isEditNotesOpen, setIsEditNotesOpen] = useState(false);

  return (
    <Box sx={{ flex: 1 }}>
      <Box
        sx={{
          mb: 1,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <Stack direction="row" spacing={1} alignItems="flex-start">
          <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
            Notes
          </Typography>
          {editMode && (
            <IconButton size="small" sx={editButtonOffsetSx} onClick={() => setIsEditNotesOpen(true)}>
              <MoreHorizIcon />
            </IconButton>
          )}
        </Stack>
      </Box>
      <Typography variant="body2">{notes || '-'}</Typography>
      <EditNotesDialog
        open={isEditNotesOpen}
        label="Notes"
        initialValue={notes ?? ''}
        onClose={() => setIsEditNotesOpen(false)}
        onSave={(newNotes) => {
          onSaveNotes(newNotes);
          setIsEditNotesOpen(false);
        }}
      />
    </Box>
  );
};
